import * as React from 'react';
import {
  IconFiletypeDicom,
  IconFiletypeDoc,
  IconFiletypeJpg,
  IconFiletypePdf,
  IconFiletypePng,
  IconFiletypePpt,
  IconFiletypeRtf,
  IconFiletypeTiff,
  IconFiletypeUnknown,
  IconFiletypeXls,
  IconFilm,
  IconFiletypeZip,
  IconMusicNotes,
  IconFileTypeBdt,
} from './Icons';

// The case values are copied from file-exchange.js
const RenderFileIcon = ({ mime }) => {
  const lastMimePart = mime.split('/').reverse()[0];
  switch (lastMimePart.toLowerCase()) {
    case 'dicom':
      return <IconFiletypeDicom size="12" />;
    case 'pdf':
      return <IconFiletypePdf size="12" />;
    case 'png':
      return <IconFiletypePng size="12" />;
    case 'jpeg':
      return <IconFiletypeJpg size="12" />;
    case 'tiff':
      return <IconFiletypeTiff size="12" />;
    case 'excel':
    case 'msexcel':
    case 'x-excel':
    case 'x-msexcel':
    case 'vnd.ms-excel':
    case 'vnd.oasis.opendocument.spreadsheet':
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return <IconFiletypeXls size="12" />;
    case 'powerpoint':
    case 'mspowerpoint':
    case 'x-mspowerpoint':
    case 'vnd.ms-powerpoint':
    case 'vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'vnd.oasis.opendocument.presentation':
      return <IconFiletypePpt size="12" />;
    case 'doc':
    case 'msword':
    case 'vnd.ms-word':
    case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'ms-doc':
    case 'vnd.oasis.opendocument.text':
      return <IconFiletypeDoc size="12" />;
    case 'zip':
      return <IconFiletypeZip size="12" />;
    case 'rtf':
    case 'richtext':
    case 'x-rtf':
      return <IconFiletypeRtf size="12" />;
    case 'quicktime':
    case 'mpeg':
      return <IconMusicNotes size="12" />;
    case 'mp4':
      return <IconFilm size="12" />;
    case 'bdt':
      return <IconFileTypeBdt size="12" />;
    default:
      return <IconFiletypeUnknown size="12" />;
  }
};

export default RenderFileIcon;
